// removed by extract-text-webpack-plugin
module.exports = {"wrap-top-business":"wrap-top-business","top-business-list":"top-business-list","top-business-item":"top-business-item","top-business-item-wrap-img":"top-business-item-wrap-img","top-business-item-name":"top-business-item-name"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_TopBusinessTab.scss
// module id = ./components/home/sub-view/_TopBusinessTab.scss
// module chunks = 0